import { Fragment } from 'react';
import CompleteStepIcon from '../../assets/icons/CompleteStepIcon.svg?react';
import CurrentStepIcon from '../../assets/icons/CurrentStepIcon.svg?react';
import InactiveStepIcon from '../../assets/icons/InactiveStepIcon.svg?react';
import { cn } from '../../utils/classNames';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import {
  stepperConnectorClasses,
  stepperDividerClasses,
  stepperIconClasses,
  stepperIconInactiveClasses,
  stepperLabelActiveClasses,
  stepperLabelClasses,
  stepperRowClasses,
  stepperStepClasses
} from './easyModeClasses';

const renderStepIcon = ({ step, currentStep }) => {
  if (step < currentStep) return <CompleteStepIcon className={stepperIconClasses} />;
  if (step === currentStep) return <CurrentStepIcon className={stepperIconClasses} />;

  return <InactiveStepIcon className={stepperIconInactiveClasses} />;
};

const EasyModeStepper = ({ steps, currentStep, onStepClick, isNavigationDisabled = false }) => (
  <>
    <div className={stepperRowClasses} data-tour={TOUR_TARGETS.EASY_MODE_STEPPER}>
      {steps.map(({ step, label }, index) => (
        <Fragment key={step}>
          <div className={stepperStepClasses}>
            {renderStepIcon({ step, currentStep })}
            <button
              type="button"
              className={cn(
                stepperLabelClasses,
                step <= currentStep && stepperLabelActiveClasses,
                isNavigationDisabled && 'cursor-not-allowed opacity-50'
              )}
              disabled={isNavigationDisabled}
              onClick={() => onStepClick({ step })}
            >
              {label}
            </button>
          </div>
          {index < steps.length - 1 && <span className={stepperConnectorClasses} />}
        </Fragment>
      ))}
    </div>
    <div className={stepperDividerClasses} />
  </>
);

export default EasyModeStepper;
